// extracted by mini-css-extract-plugin
export default {"CloseButton":"CustomToast_CloseButton__+Jf2N","Icon":"CustomToast_Icon__Fk32+"};